// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './request/api/index'
import globalApi from './request/globalApi.js'

//引入echart
//将echarts引入到vue的原型中
import echarts from 'echarts'

Vue.prototype.$echarts = echarts

// 挂在element  
Vue.use(ElementUI);

// 引入粒子特效 vue-particles
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

import VueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(VueSeamlessScroll)

// DataV 按需注册，避免把未使用的图表和装饰组件打进大屏包。
import dataVBorderBox13 from '@jiaminghi/data-view/lib/components/borderBox13'
import dataVDecoration5 from '@jiaminghi/data-view/lib/components/decoration5'
Vue.use(dataVBorderBox13)
Vue.use(dataVDecoration5)
// Vue.prototype.$baseUrl = '/api'
//axios
Vue.prototype.$api = api.article

Vue.config.productionTip = false

Vue.prototype.$globalApi = globalApi

Vue.prototype.$baseUrl = process.env.NODE_ENV === 'production' ? globalApi.proUrl + '/' : 'https://zlssdev.yyangpt.cn/'
//echarts  自适应问题
Vue.prototype.$echartsResize = function (ref) {
  window.addEventListener('resize', function () {
    ref.resize()
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js